import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { createEmptyFilters, FileLibraryState } from './file-library.model';

export function createInitialState(): FileLibraryState {
	return {
		directoryTree: [],
		directoryContent: [],
		selectedDirectoryId: null,
		uploadingFiles: [],
		completedUploads: [],
		loading: false,
		loadingContent: false,
		loadingMore: false,
		error: null,
		currentPage: 1,
		perPage: 50,
		totalItems: 0,
		hasMore: false,
		// Collections state
		collections: [],
		selectedCollectionId: null,
		loadingCollections: false,
		treeError: null,
		collectionsError: null,
		// Content cache state
		contentCacheKey: null,
		contentCacheTimestamp: 0,
		// Filter state (Phase 1)
		activeFilters: createEmptyFilters(),
		filterOptions: null,
		loadingFilterOptions: false,
		// Folder permissions
		currentFolderUserRole: null,
		savedSearchFilters: null,
		loadingSavedSearchFilters: false
	};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'file-library', resettable: true })
export class FileLibraryStore extends Store<FileLibraryState> {
	constructor() {
		super(createInitialState());
	}
}
